// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__205Za","title":"InfoRow_title__f10z2"};